module.exports = __webpack_public_path__ + "media/images/athletes/3520-d4a5e2955b9ca91f7af61ab5de0fc507.png";